export const siteMeta = { name: "NeuroScan", domain: "neuroscanapp.io" };

export const navHrefs = ["#features", "#how-it-works", "#reports", "#use-cases", "#pricing", "#faq"];

export const footerHrefs = {
  product: ["#features", "#reports", "#pricing"],
  company: ["#hero", "#final-cta"],
};

export const heroMetricValues = ["94.2%", "< 50ms", "120+"];

export const featureIcons = ["ScanFace", "Activity", "Eye", "Users", "Brain", "FileSpreadsheet", "ShieldCheck", "AudioLines"];
export const featureNums = ["01", "02", "03", "04", "05", "06", "07", "08"];

export const howItWorksIcons = ["Video", "ScanFace", "FileText", "Target"];
export const howItWorksStepNums = ["01", "02", "03", "04"];

export const reportPreviewData = {
  date: "21.06.2026",
  metricValues: [
    { value: "8.7", unit: "/10" },
    { value: "32", unit: "%" },
    { value: "24:18", unit: "" },
  ],
  statusComplete: "COMPLETE",
  chart: [
    { t: "00:00", emotion: 40, trust: 70 },
    { t: "02:00", emotion: 55, trust: 72 },
    { t: "04:00", emotion: 48, trust: 68 },
    { t: "06:00", emotion: 72, trust: 75 },
    { t: "08:00", emotion: 65, trust: 62 },
    { t: "10:00", emotion: 58, trust: 58 },
    { t: "12:00", emotion: 80, trust: 65 },
    { t: "14:00", emotion: 74, trust: 70 },
    { t: "16:00", emotion: 68, trust: 78 },
    { t: "18:00", emotion: 85, trust: 82 },
    { t: "20:00", emotion: 78, trust: 85 },
    { t: "22:00", emotion: 82, trust: 88 },
  ],
  keyMomentTimes: ["04:12", "08:45", "15:30"],
};

export const useCaseIcons = ["UserCheck", "Handshake", "Brain", "Search"];
export const useCaseIds = ["hiring", "negotiations", "psychology", "investigation"];

export const testimonialPhotos = [
  "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1699899657680-421c2c2d5064?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85",
];
export const testimonialAuthors = ["Elena V.", "Andrey K.", "Maria S.", "Igor N."];

export const pricingPlanMeta = [
  { id: "starter", name: "Starter", monthlyPrice: 9.99, quotaMinutes: 20, highlighted: false },
  { id: "professional", name: "Professional", monthlyPrice: 29.99, quotaMinutes: 60, highlighted: true },
  { id: "enterprise", name: "Enterprise", monthlyPrice: 89.99, quotaMinutes: 300, highlighted: false },
];

export const googlePlayUrl = "https://play.google.com/store/apps/details?id=com.neuroscan.app";

export const finalCtaEmail = "support@neuroscanapp.io";

import {
  FACE_VIEWBOX_H, HANDS_VIEWBOX_H, POSE_VIEWBOX_H,
  FACE_MESH_LINES, FACE_CONTOUR_LINES, FACE_POINTS,
  HAND_LINES, HAND_POINTS,
  POSE_LINES, POSE_POINTS,
} from "./liveDemoLandmarks";

// Coordinates below come from real MediaPipe Face Mesh (468 pts) / Hands
// (21 pts x2) / Pose (33 pts) detections run once against these exact
// photos — see /app/scripts/generate_landmarks.py. No camera or ML runtime
// is used in production; this is a pre-baked, anatomically accurate overlay.
// viewBoxH matches each photo's true aspect ratio so the SVG overlay (using
// preserveAspectRatio="xMidYMid slice") crops identically to the <img>'s
// object-cover, keeping the mesh pixel-aligned at any screen size.
export const liveDemoTabs = [
  {
    id: "face",
    icon: "ScanFace",
    image: "https://images.unsplash.com/photo-1616840420121-7ad8ed885f11?crop=entropy&cs=srgb&fm=jpg&q=85",
    color: "#00F0FF",
    viewBoxH: FACE_VIEWBOX_H,
    meshLines: FACE_MESH_LINES,
    contourLines: FACE_CONTOUR_LINES,
    points: FACE_POINTS,
  },
  {
    id: "hands",
    icon: "Hand",
    image: "https://images.unsplash.com/photo-1517055813639-0ae179305650?crop=entropy&cs=srgb&fm=jpg&q=85",
    color: "#00F0FF",
    viewBoxH: HANDS_VIEWBOX_H,
    lines: HAND_LINES,
    points: HAND_POINTS,
  },
  {
    id: "pose",
    icon: "PersonStanding",
    image: "https://images.unsplash.com/photo-1632387169943-3f254ead7300?crop=entropy&cs=srgb&fm=jpg&q=85",
    color: "#00F0FF",
    viewBoxH: POSE_VIEWBOX_H,
    lines: POSE_LINES,
    points: POSE_POINTS,
  },
  {
    id: "voice",
    icon: "AudioLines",
    color: "#00F0FF",
  },
];
